import React from "react";

export default class YearlyGanttTable extends React.Component {

 
    render() {


        return (
            <div className="w-100" style={{ height: "600px", border: "0.1px solid #EBEDF1", borderBottom: "none", borderTop: "none", display: "flex", flexDirection: "row" }}>

                        <div className="cell w-100"
                        >


                        </div>
                 
            </div>

        )
    }
}